






















































































































































































































































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import { maskCPFCNPJ, maskDate, maskHour, timeout, timeoutDefault } from '@/utils/common'
import EventBus from '@/plugins/EventBus'

@Component
export default class ComponenteBackofficePaciente extends Vue {
  @Prop({ default: '', required: false }) parentModal: string
  @Prop({ default: false }) canShowCategoriaDoPlanoParaFidelizacao

  modalAdicionarPaciente: boolean = false
  modalConfirmaPacienteDuplicado: boolean = false
  loadBuscarPaciente: boolean = false
  loadModalAdicionarPaciente: boolean = false
  loadAdicionarPaciente: boolean = false
  loadCloseBuscarPaciente: boolean = false
  loadCloseAdicionarPaciente: boolean = false
  pais: string = ''

  get paisId() { return this.pais }
  set paisId(value: string) { this.pais = value }

  $refs!: { formNacionalidade: any }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get loadingBuscarPaciente() {
    return this.loadBuscarPaciente
  }

  set loadingBuscarPaciente(value: boolean) {
    this.loadBuscarPaciente = value
  }

  get loadingModalAdicionarPaciente() {
    return this.loadModalAdicionarPaciente
  }

  set loadingModalAdicionarPaciente(value: boolean) {
    this.loadModalAdicionarPaciente = value
  }

  get loadingCloseBuscarPaciente() {
    return this.loadCloseBuscarPaciente
  }

  set loadingCloseBuscarPaciente(value: boolean) {
    this.loadCloseBuscarPaciente = value
  }

  get loadingCloseAdicionarPaciente() {
    return this.loadCloseAdicionarPaciente
  }

  set loadingCloseAdicionarPaciente(value: boolean) {
    this.loadCloseAdicionarPaciente = value
  }

  get loadingAdicionarPaciente() {
    return this.loadAdicionarPaciente
  }

  set loadingAdicionarPaciente(value: boolean) {
    this.loadAdicionarPaciente = value
  }

  get nomeHospital() {
    return this.getBackofficeGlobalStore.solicitacao
      && this.getBackofficeGlobalStore.solicitacao.hospital
      && this.getBackofficeGlobalStore.solicitacao.hospital.nome
      ? this.getBackofficeGlobalStore.solicitacao.hospital.nome
      : 'Hospital'
  }

  get categoriaCoberturaVigente() {
    const { hospital, paciente } = this.getBackofficeGlobalStore.solicitacao
    if (
      !hospital!.hospitalFazConsultaCoberturaVigente
      || hospital!.tipoDeCoberturaVigente !== 'Categoria'
      || paciente.categoriaCoberturaVigente === undefined) return undefined
    return paciente.categoriaCoberturaVigente
  }

  get categoriaCoberturaVigenteText() {
    return `${this.getBackofficeGlobalStore.solicitacao.paciente.categoriaNome} <i class="las la-exclamation-circle" style="font-size: 22px; color: #D32F2F; transform: translateY(2px)" title="Esta categoria não tem cobertura"></i>`
  }

  get categoriaTexto() {
    const nome = this.getBackofficeGlobalStore.solicitacao.paciente.categoriaNome || 'Não informado'
    if (this.getBackofficeGlobalStore.solicitacao.categoriaEscolhidaAPartirDoConvenio) {
      return `${nome} (Categoria escolhida pelo convênio)`
    }
    return nome
  }

  get categoriaDoPlanoParaFidelizacao() {
    return this.getBackofficeGlobalStore.solicitacao.categoriaDoPlanoParaFidelizacao!
  }

  set categoriaDoPlanoParaFidelizacao(value: string) {
    this.getBackofficeGlobalStore.solicitacao.categoriaDoPlanoParaFidelizacao = value
  }

  changeCategoriaDoPlanoParaFidelizacao(categoria: string) {
    this.$emit('changeCategoriaDoPlanoParaFidelizacao', categoria)
  }

  get getTemplate() {
    return this.getBackofficeGlobalStore.template.formulario
  }

  titulo(field: string, defaultValue: string) {
    if (this.getTemplate && this.getTemplate[field]) {
      const campo = this.getTemplate[field]
      return (campo && campo.titulo) || defaultValue
    }

    return defaultValue
  }

  formatDate(date: string) {
    return maskDate(date)
  }

  maskCpfCnpjUtil(documento: string) {
    return maskCPFCNPJ(documento)
  }

  formatHour(date: string) {
    return maskHour(date)
  }

  formatarDataNascimento() {
    return `${maskDate(this.getBackofficeGlobalStore.solicitacao.paciente.dataNascimento || '')} ${this.getBackofficeGlobalStore.solicitacao.paciente.idade} anos`
  }

  async showModalBuscarPaciente() {
    this.loadingBuscarPaciente = true
    await timeout(800)
    this.getBackofficeGlobalStore.setShowModalBuscarPaciente(true)
    this.loadingBuscarPaciente = false
  }

  async showModalAdicionarPaciente() {
    this.loadingModalAdicionarPaciente = true
    await timeout(800)
    this.modalAdicionarPaciente = true
    this.loadingModalAdicionarPaciente = false
  }

  async closeModalBuscarPaciente() {
    this.loadingCloseBuscarPaciente = true
    await timeoutDefault()
    this.getBackofficeGlobalStore.setShowModalBuscarPaciente(false)
    this.loadingCloseBuscarPaciente = false
  }

  async closeModalAdicionarPaciente() {
    this.loadingCloseAdicionarPaciente = true
    await timeoutDefault()
    this.modalAdicionarPaciente = false
    this.loadingCloseAdicionarPaciente = false
  }

  async adicionarPaciente(confirmaCriacaoComPacienteDuplicado: boolean = false) {
    this.loadingAdicionarPaciente = true
    const params: any = {
      solicitacaoId: this.getBackofficeGlobalStore.solicitacao.id,
      adicionaPacienteNoHis: this.getBackofficeGlobalStore.adicionaPaciente,
      confirmaCriacaoComPacienteDuplicado,
    }

    if (this.paisId) {
      params.paisId = this.paisId
    }

    const response = await this.getBackofficeGlobalStore.backofficeAgendamentoAdicionarPaciente(params)

    if (!response.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: 'Não foi possivel adicionar o paciente',
        icon: 'warning',
        color: '#C62828',
      })
      this.loadingAdicionarPaciente = false
      return
    }

    if (response.data && response.data.temPacienteDuplicado) {
      this.loadingAdicionarPaciente = false
      this.modalConfirmaPacienteDuplicado = true
      return
    }

    EventBus.$emit('setSnackbar', { show: true, text: 'Paciente adicionado com sucesso!', icon: 'done', color: '#2E7D32' })
    this.getBackofficeGlobalStore.setSolicitacaoFields({ field: 'temPendenciaDePaciente', value: false })
    if (params && params.paisId) this.getBackofficeGlobalStore.setSolicitacaoFields({ field: 'temPendenciaDePacientePais', value: false })
    this.closeModalAdicionarPaciente()
    this.loadingAdicionarPaciente = false
  }

  async confirmarAdicionarPacienteComDuplicidade() {
    this.modalConfirmaPacienteDuplicado = false
    await this.adicionarPaciente(true)
  }

  cancelarAdicionarPacienteDuplicado() {
    this.modalConfirmaPacienteDuplicado = false
    this.closeModalAdicionarPaciente()
  }

  getComorbidadeDescricao(comorbidade) {
    if (comorbidade.descricao) return comorbidade.descricao
    switch (comorbidade.comorbidade) {
      case 'HistoricoDeCardiopatiaHisquemica':
        return 'Histórico de cardiopatia hisquêmica'
      case 'HistoricoDeInsuficienciaCardiaca':
        return 'Histórico de insuficiência cardíaca'
      case 'HistoricoDeDoencaVascularCerebral':
        return 'Histórico de doença vascular cerebral'
      case 'Diabetes':
        return 'Diabetes'
      case 'Obesidade':
        return 'Obesidade'
      case 'ArritimiaCardiacaPorFibrilacaoAuricular':
        return 'Arritima cardíaca por fibrilação auricular (ACFA)'
      case 'PacientePossuiLiberacaDoClinicoOuCardiologista':
        return 'Paciente possui liberação do clínico geral/cardiologista'
      default:
        return ''
    }
  }

  get temPendenciaDePacientePais() {
    return !!this.getBackofficeGlobalStore.solicitacao.temPendenciaDePacientePais
  }

  formNacionalidadeRules: any = {
    valid: true,
    nacionalidade: [(v: any) => !!v || 'Campo obrigatório.'],
  }

  get disabledButtonAdicionarPaciente() {
    return this.temPendenciaDePacientePais && !this.paisId
  }

  capitalizeFirstLetter(string: string) {
    return string.charAt(0).toUpperCase() + string.slice(1)
  }

  @Watch('modalAdicionarPaciente')
  onChangeModalAdicionarPaciente(value: boolean) {
    if (!value) {
      this.paisId = ''
      if (this.getBackofficeGlobalStore.solicitacao.temPendenciaDePacientePais !== undefined && !!this.$refs.formNacionalidade) {
        this.$refs.formNacionalidade.resetValidation()
      }
    }
  }
}
